"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var eventsHelper_1 = require("../utils/eventsHelper");
var SearchForm = /** @class */ (function () {
    function SearchForm(rootElement) {
        var _this = this;
        this.rootElement = rootElement;
        // Click event for toggle search form
        eventsHelper_1.default.live('.js-toggle-search', eventsHelper_1.default.clickOrTouchEvent, function (event, clickedElement) {
            var _a;
            if (clickedElement) {
                var elementId = clickedElement.dataset.elementId;
                var element = _this.rootElement.querySelector('[data-element-id=' + elementId + ']:not(.js-toggle-search)');
                if (!element)
                    return false;
                // Set is-open to search input also
                var searchInputElement = (_a = element.closest('.o-search-input')) !== null && _a !== void 0 ? _a : element;
                if (searchInputElement && !searchInputElement.classList.contains('is-open')) {
                    searchInputElement.classList.add('is-open');
                    if (clickedElement) {
                        clickedElement.removeAttribute("onclick");
                    }
                    return false;
                }
                // Submit form
                var form = clickedElement.closest('form');
                if (form) {
                    form.submit();
                    return false;
                }
            }
        }, this.rootElement);
    }
    return SearchForm;
}());
exports.default = SearchForm;
